import { Button, type ButtonProps, Link, type LinkProps } from '@mui/material';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

import { getRel } from '@@utils/browser';

const LinkAnchor = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
    <Link {...props} ref={ref} />
));

// A plain anchor, without the `rel` default the theme's link component adds
const ButtonAnchor = forwardRef<HTMLAnchorElement, ButtonProps<'a'>>((props, ref) => (
    <Button rel={getRel(props.target)} {...props} ref={ref} component="a" />
));

export const RouterLink = createLink(LinkAnchor);

export const RouterButton = createLink(ButtonAnchor);
